import { render, staticRenderFns } from "./ListProduk.vue?vue&type=template&id=0ed3a42c&scoped=true&"
import script from "./ListProduk.vue?vue&type=script&lang=js&"
export * from "./ListProduk.vue?vue&type=script&lang=js&"
import style0 from "./ListProduk.vue?vue&type=style&index=0&id=0ed3a42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed3a42c",
  null
  
)

export default component.exports